import { render, staticRenderFns } from "./CodigosPostales.vue?vue&type=template&id=7a4552ad&scoped=true&"
import script from "./CodigosPostales.vue?vue&type=script&lang=js&"
export * from "./CodigosPostales.vue?vue&type=script&lang=js&"
import style0 from "./CodigosPostales.vue?vue&type=style&index=0&id=7a4552ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4552ad",
  null
  
)

export default component.exports